import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { CloudForwarderForwarders } from "@graylog/enterprise-api";
const useDisconnectedForwarders = () => {
  var _a;
  const { data, isFetching } = useQuery({
    queryKey: ["forwarder", "forwarders", "disconnected"],
    queryFn: () => CloudForwarderForwarders.list("title", 1, 0, void 0, "asc", "disconnected"),
    placeholderData: keepPreviousData,
    refetchInterval: 5e3
  });
  const disconnectedForwarderIds = ((_a = data == null ? void 0 : data.forwarders) != null ? _a : []).map(
    (f) => f.id
  );
  return { disconnectedForwarderIds, isFetching };
};
export default useDisconnectedForwarders;
